<template>
  <TabGroup>
    <TabList class="flex gap-2 p-2 text-dimmed text-xl my-2">
      <MapIcon class="h-6" />
      <Tab v-slot="{ selected }" as="template">
        <button class="ring-none focus:outline-none" :class="{ 'text-quicklist': selected }">{{ $t("Cities") }}</button>
      </Tab>
      <span> / </span>
      <Tab v-slot="{ selected }" as="template">
        <button class="ring-none focus:outline-none" :class="{ 'text-quicklist': selected }">
          {{ $t("Countries") }}
        </button>
      </Tab>
    </TabList>

    <TabPanels class="p-2 lg:p-0">
      <TabPanel>
        <QuickListCities :cities="quicklist.cities" />
      </TabPanel>
      <TabPanel>
        <QuickListCountries :countries="quicklist.countries" />
      </TabPanel>
    </TabPanels>
  </TabGroup>
</template>

<script setup>
import { MapIcon } from "@heroicons/vue/24/outline";
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";
import { ref } from "vue";
import brandconfig from "@/brandconfig";

import { QuickListCities, QuickListCountries } from ".";

const quicklist = ref(brandconfig.quicklist);
</script>
